package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.data.remote.FirebaseStorageClient
import com.evoapps.evoshift.domain.repository.ClockPhotoRepository

/**
 * SH-134: the tablet's clock-in photos in Storage through [FirebaseStorageClient] (storage.rules:
 * only the workplace's own tablet uploads, only its managers read; deleted after 30 days).
 */
class ClockPhotoRepositoryImpl(private val storage: FirebaseStorageClient) : ClockPhotoRepository {
    override suspend fun upload(path: String, jpeg: ByteArray): Result<Unit> = runCatching {
        require(isClockPhotoPath(path)) { "Not a clock photo path" }
        storage.upload(path, jpeg, CONTENT_TYPE)
        Unit
    }

    override suspend fun download(path: String): Result<ByteArray> = runCatching {
        require(isClockPhotoPath(path)) { "Not a clock photo path" }
        storage.download(storage.downloadUrl(path, null))
    }

    companion object {
        const val CONTENT_TYPE = "image/jpeg"

        /** `clock_photos/{workplaceId}/{kioskId}/{file}.jpg`, as kioskClock makes them. */
        fun isClockPhotoPath(path: String): Boolean {
            val parts = path.split('/')
            return parts.size == 4 && parts[0] == "clock_photos" && parts.drop(1).all { it.isNotBlank() && it != ".." } &&
                parts[3].endsWith(".jpg")
        }
    }
}
